import { ButtonHTMLAttributes, useEffect, useState } from 'react'

import { LocalVideoTrack } from 'livekit-client'

import { useMaybeRoomContext } from '@/src/context'
import { BgEffect, BgEffectOptions } from '@/src/lib/types'
import { ImageIcon } from '@/accets/icons'
import { useAppSelector } from '@/src/store/hooks'
import { selectBranding } from '@/src/store/slices/meetData'

export interface ImgSwitcherProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  setBgEffect: (effect: BgEffect | null) => React.MouseEventHandler<HTMLButtonElement> | void
  currentBgEffect: BgEffect | null
  track: LocalVideoTrack
}

export function ImgSwitcher({ setBgEffect, currentBgEffect, track, ...props }: ImgSwitcherProps) {
  const bgEffectFromLocalStorage = JSON.parse(localStorage.getItem('lk-user-choices') || '{}')
    ?.currentBgEffect?.type
  const [isActive, setIsActive] = useState<string>(
    bgEffectFromLocalStorage === 'virtual-background' ? 'active' : '',
  )
  const {
    text_primary_color,
    border_radius: borderRadius,
    img_background_speaker,
  } = useAppSelector(selectBranding)

  const images: BgEffectOptions[] = [
    {
      id: '1',
      imagePath: img_background_speaker,
      name: 'Картинка 1',
    },
  ]

  useEffect(() => {
    setIsActive(currentBgEffect?.type === 'virtual-background' ? 'active' : '')
  }, [currentBgEffect])

  const maybeRoomContext = useMaybeRoomContext()
  useEffect(() => {
    if (bgEffectFromLocalStorage === 'virtual-background' && currentBgEffect === null) {
      if ((!track && !maybeRoomContext) || track) {
        setBgEffect({
          type: 'virtual-background',
          options: {
            id: '1',
            name: 'Картинка 1',
            imagePath: img_background_speaker,
          },
        })
        setIsActive('active')
      }
    }
  }, [])

  return (
    <div>
      {images.map((image) => (
        <button
          key={image.id}
          aria-label={image?.name}
          className={['lk-button-bg-effects', isActive].join(' ')}
          style={{
            borderColor: isActive ? text_primary_color : 'transparent',
            borderRadius,
          }}
          onClick={() => setBgEffect({ type: 'virtual-background', options: image })}
        >
          <ImageIcon stroke="red" fill={text_primary_color} width={36} height={36} />
        </button>
      ))}
    </div>
  )
}
